import React from "react";

export default function Logo({ className = "", alt = "Pebbledash" }) {
  const classes = className ? `pd-logo-image ${className}` : "pd-logo-image";

  return <img src="/Pebbledash_logo.png" alt={alt} className={classes} />;
}
